<div class="show-comments-button" *ngIf="userIds && (!isCurrentUserViewOnly || commentsCount > 0)" (click)="showCommentsButtonClick.emit()">
  <!-- TODO: an upper ajs component is passing the commentsCount value as a string - switch to triple equal (===) after migrating reactions-with-comments.directive.ts -->
  <div class="post-comment" *ngIf="commentsCount === 0">
    <div class="icon">
      <div class="gh-icon gh-icon-comments-outline"></div>
    </div>
    <div>{{ "post_a_comment" | localize }}</div>
  </div>
  <div class="comments-summary" *ngIf="commentsCount > 0">
    <ui-assignee-avatar-group [uiMax]="avatarPreviewNumber" [fromAssigneeIds]="userIds" uiSize="xs" ui-align-right></ui-assignee-avatar-group>
    <div class="counter">
      <div>{{ commentsCount }}</div>
      <div>{{ (commentsCount > 1 ? "comments" : "comment") | localize }}</div>
    </div>
  </div>
</div>
